<ion-menu contentId="main-content">
	<app-drawer />
</ion-menu>

<ion-tabs id="main-content">
	<ion-tab-bar slot="bottom" class="h-20 bg-(--ion-color-dark)">
		<ion-tab-button tab="home" href="/home">
			<ion-icon name="home-outline"></ion-icon>
			<ion-label>{{ 'Home' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button tab="in-play" href="/in-play">
			<ion-icon name="stopwatch-outline"></ion-icon>
			<ion-label>{{ 'In-Play' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button tab="my-markets" href="/my-markets">
			<ion-icon name="star"></ion-icon>
			<ion-label>{{ 'My Markets' | translate }}</ion-label>
		</ion-tab-button>

		<ion-tab-button tab="my-bets" href="/my-bets">
			<ion-icon name="document-text-outline"></ion-icon>
			<ion-label>{{ 'My Bets' | translate }}</ion-label>
		</ion-tab-button>
	</ion-tab-bar>
</ion-tabs>
